import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import NavbarId from "./data/lang/id/navbar.json";
import NavbarEn from "./data/lang/en/navbar.json";

import HeroId from "./data/lang/id/home/hero.json";
import HeroEn from "./data/lang/en/home/hero.json";

import AboutId from "./data/lang/id/home/about.json";
import AboutEn from "./data/lang/en/home/about.json";
import PodiumHomeId from "./data/lang/id/home/podium-categeory.json";
import PodiumHomeEn from "./data/lang/en/home/podium-categeory.json";
import PrizeHomeId from "./data/lang/id/home/prize.json";
import PrizeHomeEn from "./data/lang/en/home/prize.json";

import FrontlinerId from "./data/lang/id/frontliner.json";
import FrontlinerEn from "./data/lang/en/frontliner.json";

import RulesRegulationId from "./data/lang/id/race-information/rules-regulation.json";
import RulesRegulationEn from "./data/lang/en/race-information/rules-regulation.json";

import faqId from "./data/lang/id/race-information/faq.json";
import faqEn from "./data/lang/en/race-information/faq.json";

import PrizeId from "./data/lang/id/race-information/prize.json";
import PrizeEn from "./data/lang/en/race-information/prize.json";

import ContactId from "./data/lang/id/contact-us.json";
import ContactEn from "./data/lang/en/contact-us.json";

import RaceDayId from "./data/lang/id/race-information/raceday.json";
import RaceDayEn from "./data/lang/en/race-information/raceday.json";

import RegistrationId from "./data/lang/id/registration.json";
import RegistrationEn from "./data/lang/en/registration.json";

import RegistrationGroupEn from "./data/lang/en/registration-group.json";
import RegistrationGroupId from "./data/lang/id/registration-group.json";

const resources = {
    en: {
        translation: {
            navbar: NavbarEn,
            hero: HeroEn,
            footer: {
                page: "Pages",
                social: "Social Media",
                powered: "Main Sponsor",
                manage: "Managed By",
                govt: "Government Partner By",
                mineral: "Official Mineral Water",
                isotonic: "Official Isotonic Partner",
                insurance: "Official Insurance",
                healthydrink: "Official Natural Healthy Drink",
                cosponsor: "Co Sponsor",
                mediapartner: "Media Partner",
            },
            home: {
                about: AboutEn,
                podium: PodiumHomeEn,
                prize: PrizeHomeEn,
                register1: "Register",
                register2: "Now",
            },
            raceinfo: {
                rrHeader: "Rules & Regulations",
                rrTitle:
                    "All participants are required to read and understand the rules and regulations below before registering for the Tangerang 10K.",
                rr: RulesRegulationEn,
            },
            frontliner: {
                title: "The Frontliner",
                button1: "Register",
                button2: "Now",
                content: FrontlinerEn,
            },
            registrationFrontlinerTitle: "Registration Form - The Frontliner",
            prize: PrizeEn,
            prizeTitle: "Winner",
            raceResultTitle: "Race Result",
            faq: faqEn,
            raceday: RaceDayEn,
            racedayTitle: "Race Day",
            contact: ContactEn,
            registrationTitle: "Registration",
            registrationGroupVoucherTitle: "Purchase Form - Group of 3 Vouchers",
            specialProgramTitle: "Special Program",
            registrationClosedTitle: "Registration Closed",
            redeemVoucherTitle: "Redeem Voucher",
            invitationTitle: "Invitation",
            registrationCoupon: "Dapatkan <strong>potongan sebesar Rp 225.000,-</strong> untuk program '<strong>Group of 3</strong>' dengan mendaftarkan 3 peserta  menggunakan kode kupon <strong>BANDUNGKEMBALI</strong>.",
            registration: RegistrationEn,
            registrationGroup: {
                title: "Group of 3 Program",
                subTitle: "Terms & Conditions for the Tangerang 10K 2026 Group of 3 Voucher Purchase Program",
                content: RegistrationGroupEn,
                button1: "Sold",
                button2: "Out"
            },
            galleryTitle: "Race Gallery",
            profile: {
                title: "Profile",
                actions: {
                    registerEvent: "Register Event",
                    eventHistory: "Event History",
                },
                sections: {
                    personalInfo: "Personal Information"
                },
                fields: {
                    uusrName: "Name",
                    uusrEmail: "Email",
                    uusrPhoneNumber: "Phone Number",
                    uusrGender: "Gender",
                    uusrBloodType: "Blood Type",
                    uusrNationality: "Nationality",
                    uusrIdentityType: "Identity Type",
                    uusrIdentityNumber: "Identity Number",
                    uusrDateOfBirth: "Date of Birth",
                    uusrOccupation: "Occupation",
                    uusrCommunity: "Community",
                },
                gender: {
                    1: "Male",
                    2: "Female",
                },
                identityType: {
                    1: "ID CARD",
                    2: "PASSPORT",
                },
                eventHistory: {
                    title: "My Event History",
                    empty: "No event history found",
                    emptyDescription: "You haven't registered for any events yet. Start exploring our events!",
                    total: "Total Events",
                    paid: "Paid",
                    pending: "Pending",
                    expired: "Expired",
                    fields: {
                        refId: "Registration Code",
                        status: "Status",
                        date: "Registration Date",
                    },
                    status: {
                        paid: "Paid",
                        pending: "Pending",
                        expired: "Expired",
                    }
                }
            }
        },
    },
    id: {
        translation: {
            navbar: NavbarId,
            hero: HeroId,
            footer: {
                page: "Halaman",
                social: "Media Sosial",
                powered: "Main Sponsor",
                manage: "Managed By",
                govt: "Government Partner By",
                mineral: "Official Mineral Water",
                isotonic: "Official Isotonic Partner",
                insurance: "Official Insurance",
                healthydrink: "Official Natural Healthy Drink",
                cosponsor: "Co Sponsor",
                mediapartner: "Media Partner",
            },
            home: {
                about: AboutId,
                podium: PodiumHomeId,
                prize: PrizeHomeId,
                register1: "Daftar",
                register2: "Sekarang",
            },
            raceinfo: {
                rrHeader: "Peraturan & Ketentuan",
                rrTitle:
                    "Para peserta diwajibkan untuk membaca seluruh peraturan & ketentuan dibawah ini secara seksama sebelum mendaftarkan diri untuk Tangerang 10K",
                rr: RulesRegulationId,
            },
            frontliner: {
                title: "The Frontliner",
                button1: "Daftar",
                button2: "Sekarang",
                content: FrontlinerId,
            },
            registrationFrontlinerTitle: "Formulir Pendaftaran - The Frontliner",
            prize: PrizeId,
            prizeTitle: "Pemenang",
            raceResultTitle: "Hasil Lomba",
            faq: faqId,
            raceday: RaceDayId,
            racedayTitle: "Pelaksanaan Lomba",
            contact: ContactId,
            registrationTitle: "Pendaftaran",
            registrationGroupVoucherTitle: "Formulir Pembelian - Voucher Group of 3",
            specialProgramTitle: "Program Special",
            registrationClosedTitle: "Pendaftaran Ditutup",
            redeemVoucherTitle: "Redeem Voucher",
            invitationTitle: "Invitation",
            registrationCoupon: "Dapatkan <strong>potongan sebesar Rp 225.000,-</strong> untuk program '<strong>Group of 3</strong>' dengan mendaftarkan 3 peserta  menggunakan kode kupon <strong>BANDUNGKEMBALI</strong>.",
            registration: RegistrationId,
            registrationGroup: {
                title: "Program Group of 3",
                subTitle: "Syarat & Ketentuan Program Pembelian Voucher Group of 3 Tangerang 10K 2026",
                content: RegistrationGroupId,
                button1: "Sold",
                button2: "Out"
            },
            galleryTitle: "Galeri Lomba",
            profile: {
                title: "Profil",
                actions: {
                    registerEvent: "Daftar Event",
                    eventHistory: "Riwayat Event",
                },
                sections: {
                    personalInfo: "Informasi Pribadi"
                },
                fields: {
                    uusrName: "Nama",
                    uusrEmail: "Email",
                    uusrPhoneNumber: "Nomor Telepon",
                    uusrGender: "Jenis Kelamin",
                    uusrBloodType: "Golongan Darah",
                    uusrNationality: "Kewarganegaraan",
                    uusrIdentityType: "Jenis Identitas",
                    uusrIdentityNumber: "Nomor Identitas",
                    uusrDateOfBirth: "Tanggal Lahir",
                    uusrOccupation: "Pekerjaan",
                    uusrCommunity: "Komunitas",
                },
                gender: {
                    1: "Laki-laki",
                    2: "Perempuan",
                },
                identityType: {
                    1: "KTP",
                    2: "PASPOR",
                },
                eventHistory: {
                    title: "Riwayat Event Saya",
                    empty: "Tidak ada riwayat event ditemukan",
                    emptyDescription: "Anda belum terdaftar di event apa pun. Mulailah menjelajahi event kami!",
                    total: "Total Event",
                    paid: "Lunas",
                    pending: "Menunggu Pembayaran",
                    expired: "Kedaluwarsa",
                    fields: {
                        refId: "Kode Pendaftaran",
                        status: "Status",
                        date: "Tanggal Pendaftaran",
                    },
                    status: {
                        paid: "Lunas",
                        pending: "Menunggu Pembayaran",
                        expired: "Kedaluwarsa",
                    }
                }
            }
        },
    },
};

i18n.use(initReactI18next).init({
    fallbackLng: "id",
    lng: "id",
    interpolation: {
        escapeValue: false,
    },
    resources: resources,
});

export default i18n;
